import {
  Box,
  Grid,
  IconButton,
  Stack,
  Typography,
  Tooltip,
} from "@mui/material";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const MiddleFooter = () => {
  return (
    <Grid item xs={12} md={4}>
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#ffffff",
            mb: 2.5,
          }}
        >
          בואו נישאר בקשר
        </Typography>

        <Stack spacing={3}>
          <Box>
            <Typography variant="body1" sx={{ mb: 2, color: "#e3f2fd" }}>
              עקבו אחרינו ברשתות החברתיות
            </Typography>

            <Stack direction="row" spacing={0} justifyContent="center">
              <Tooltip title="Instagram">
                <IconButton
                  aria-label="Instagram"
                  href="https://www.instagram.com/lev.haaretz"
                  target="_blank"
                  rel="noopener"
                  sx={{
                    color: "#ffffff",
                    transition: "all 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      color: "#E1306C",
                    },
                  }}
                >
                  <InstagramIcon fontSize="large" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Facebook">
                <IconButton
                  aria-label="Facebook"
                  href="https://www.facebook.com/profile.php?id=61586699859793"
                  target="_blank"
                  rel="noopener"
                  sx={{
                    color: "#ffffff",
                    transition: "all 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      color: "#4267B2",
                    },
                  }}
                >
                  <FacebookIcon fontSize="large" />
                </IconButton>
              </Tooltip>

              <Tooltip title="WhatsApp">
                <IconButton
                  aria-label="WhatsApp"
                  href="https://wa.me/972504599540"
                  target="_blank"
                  rel="noopener"
                  sx={{
                    color: "#ffffff",
                    transition: "all 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      color: "#25D366",
                    },
                  }}
                >
                  <WhatsAppIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Stack>
          </Box>

          <Box>
            <Typography variant="body1" sx={{ mb: 2, color: "#e3f2fd" }}>
              נווטו אלינו
            </Typography>

            <IconButton
              aria-label="Navigate with Waze"
              href="https://waze.com/ul?ll=32.44048068106908,34.91382851521554&navigate=yes"
              target="_blank"
              rel="noopener"
              sx={{
                bgcolor: "white",
                borderRadius: "50%",
                padding: 1,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                transition: "all 0.2s",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                },
              }}
            >
              <img
                src="/assets/icons/waze.svg"
                alt="Waze"
                style={{ width: 32, height: 32 }}
              />
            </IconButton>
          </Box>
        </Stack>
      </Box>
    </Grid>
  );
};

export default MiddleFooter;
